import * as React from "react";
import { classNames } from "src/common/classNames";
import { ZUid } from "src/types/zUid";
import styles from "./EntityGroupBlock.module.less";

interface PropsEntityGroupInnerBlock {
  title?: string;
  children?: React.ReactNode;
  id?: ZUid;
  monoColumn?: boolean;
}

export const EntityGroupInnerBlock: React.FC<PropsEntityGroupInnerBlock> = ({
  title,
  children,
  id,
  monoColumn,
}) => (
  <div className={styles.block} id={String(id)}>
    {!!title && <h2 className={styles.title}>{title}</h2>}
    <div className={classNames([[!monoColumn, styles.items]])}>{children}</div>
  </div>
);
